import type { Media } from "@zivin-labs/site-content";

/**
 * The Director's message, transcribed from the signed letter his office sent
 * for the site (via the BIET web coordinator, 27-08-2026).
 *
 * This replaced the placeholder the home page and About both carried — a Yeats
 * paraphrase ("Education is not the filling of a vessel…") over two paragraphs
 * that traced to no source.
 *
 * Transcribed verbatim, including one sentence in the fourth paragraph that
 * reads "The technology in our institute is concentric is updating as per…" in
 * the original. It is left as written rather than silently corrected: this is a
 * signed letter, so the wording is the Director's to change.
 *
 * Home and About render the same letter from here. They used to hold two copies
 * of it and a comment asking whoever edited one to remember the other.
 */
export const DIRECTOR = {
  name: "Prof. Y Vrushabhendrappa",
  role: "Director",
  photo: {
    url: "sites/biet/leadership/l08.jpg",
    alt: "Prof. Y Vrushabhendrappa, Director",
    width: 1991,
    height: 2560,
  } as Media,
  photoLabel: "PORTRAIT · PROF. Y VRUSHABHENDRAPPA",
  /** The letter's opening line, set as the pull quote. */
  headline:
    "Education is not just about gaining knowledge — it is about learning to innovate, solve problems, and build a better future.",
  paragraphs: [
    "Education is a fundamental pillar of national and societal development. Technical education plays a vital role in creating skilled human resources, enhancing industrial productivity, promoting innovation, and improving quality of life. Recognizing its importance, India has given significant emphasis to the expansion and strengthening of technical education.",
    "In 1952, there was only one government engineering college in the region, with admissions based purely on merit. The limited availability of seats left many aspiring students and parents without access to technical education. This need led to the establishment of Bapuji Institute of Engineering and Technology (BIET) in 1979, under the visionary leadership of Dr. Shamanur Shivashankarappa Ji, Hon. Secretary. Since its inception, the institution has made a significant contribution to technical education, with approximately 31,000 students graduating to date. The majority of the students work in various countries.",
    "The growth of education in Central Karnataka, particularly in rural areas, is closely associated with the Bapuji Educational Association, established in 1958. The Association played a pioneering role in expanding educational opportunities in the region.",
    "The institute is providing the state of art environment in emerging areas like Artificial Intelligence and CNC machines, EV vehicles and Robotics and other emerging areas. The technology in our institute is concentric is updating as per the needs of the industry and aspirations of academic bodies like University, AICTE and UGC and other policy making bodies.",
    "Since its establishment, BIET has remained committed to providing quality engineering education, fostering innovation, competitiveness, and professional excellence. The Institute strives to develop technically competent, socially responsible, and globally employable graduates who can effectively contribute to industry, society, and national development.",
  ],
};

/** What is shown before "Read the full message" opens the rest. */
export const DIRECTOR_PREVIEW = DIRECTOR.paragraphs.slice(0, 1);
